import { render } from "./EntityOrderRenderer.vue?vue&type=template&id=03c6288e"
const script = {}

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__